export interface ChoiceOptionConfig {
  label: string;
  variant?: 'primary' | 'secondary';
  italic?: boolean;
}

export const entranceSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Wait',
    variant: 'primary',
    italic: true,
  },
  {
    label: 'Approach',
    variant: 'secondary',
    italic: true,
  },
];

export const eyeContactSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Look away',
    variant: 'primary',
    italic: true,
  },
  {
    label: 'Hold the stare',
    variant: 'secondary',
    italic: true,
  },
];

export const drinkOfferSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Only if you join me',
    variant: 'primary',
  },
  {
    label: 'Yes',
    variant: 'secondary',
  },
];

export const intentQuestionSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Something real',
    variant: 'primary',
  },
  {
    label: 'Something wild',
    variant: 'secondary',
  },
];

export const closeLeanSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Don’t move',
    variant: 'primary',
    italic: true,
  },
  {
    label: 'Lean in too',
    variant: 'secondary',
    italic: true,
  },
];

export const inviteOverSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Let’s go',
    variant: 'primary',
  },
  {
    label: 'Not yet',
    variant: 'secondary',
  },
];

export const elevatorSilenceSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Touch his hand',
    variant: 'primary',
    italic: true,
  },
  {
    label: 'Let him touch first',
    variant: 'secondary',
    italic: true,
  },
];

export const elevatorCloseSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Push him',
    variant: 'primary',
    italic: true,
  },
  {
    label: 'Wait to be taken',
    variant: 'secondary',
    italic: true,
  },
];

export const unButtonShirtSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Help him',
    variant: 'primary',
    italic: true,
  },
  {
    label: 'Watch',
    variant: 'secondary',
    italic: true,
  },
];

export const stillSureSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Try me',
    variant: 'primary',
  },
  {
    label: 'Prove it',
    variant: 'secondary',
  },
];

export const waistGrabSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Pull him closer',
    variant: 'primary',
    italic: true,
  },
  {
    label: 'Push him down',
    variant: 'secondary',
    italic: true,
  },
];

export const neckBreathSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Moan',
    variant: 'primary',
    italic: true,
  },
  {
    label: 'Bite your lip',
    variant: 'secondary',
    italic: true,
  },
];

export const shakingSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Don’t stop.',
    variant: 'primary',
  },
  {
    label: 'Harder.',
    variant: 'secondary',
  },
];

export const liftUpSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Wrap your legs',
    variant: 'primary',
    italic: true,
  },
  {
    label: 'Grab his hair',
    variant: 'secondary',
    italic: true,
  },
];

export const finalConsentSceneChoices: ChoiceOptionConfig[] = [
  {
    label: 'Now.',
    variant: 'primary',
    italic: true,
  },
  {
    label: 'Deeper.',
    variant: 'secondary',
    italic: true,
  },
];
